
import { useTranslation } from "react-i18next";
import { CreateWorkspaceDialog } from "./CreateWorkspaceDialog";

interface ManageWorkspaceHeaderProps {
  onWorkspaceCreated: () => void;
}

export const ManageWorkspaceHeader = ({ onWorkspaceCreated }: ManageWorkspaceHeaderProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex justify-between items-center mb-6">
      <h1 className="text-2xl font-bold">{t('Manage workspaces')}</h1>
      <div className="flex gap-2">
        <CreateWorkspaceDialog onWorkspaceCreated={onWorkspaceCreated} />
      </div>
    </div>
  );
};
